import type { RawLoginResponse } from '@heviton/heviton-api-app-legacy';
import type { Login } from '@/shared/data-types';

/**
 * BE `RawLoginResponse` (nested `{auth, isTemporaryPassword?}`) → FE `Login` (flat).
 * `isTemporaryPassword` 가 BE 에서 omit 되면 false 로 압축.
 */
export function fromRawLogin(raw: RawLoginResponse): Login {
  return {
    accessToken: raw.auth.accessToken,
    refreshToken: raw.auth.refreshToken,
    isTemporaryPassword: raw.isTemporaryPassword ?? false,
  };
}
